import './index.scss'

const ContentWithLinkModules = document.querySelectorAll('.pagebuilder__block--content-with-links');

/**
 * Initialize the cards link interactivity
 * @param {HTMLElement} module - The .pagebuilder__block--content-with-links element for this instance
 */
function initContentWithLinks(module, root) {
    if (!module) return;
    
    const ImagesContainer = module.querySelector('.block__images');
    if (!ImagesContainer) return;

    const Cards = module.querySelectorAll('.card--mini-link');
    if (!Cards) return;

    const DefaultImage = ImagesContainer.querySelector('.block__image.focused') || null;
    let activeCard = null;
        
    function getLinkedImage(card) {
        const imageId = card?.dataset?.image;
        return imageId ? document.getElementById(imageId) : null;
    }
    
    function applyFocus(card) {
        card.classList.add('focused');
        getLinkedImage(card)?.classList.add('focused');  
    }

    function removeFocus(card) {
        card.classList.remove('focused');
        getLinkedImage(card)?.classList.remove('focused');
    }

    function clearActive() {
        if (!activeCard) return;
        removeFocus(activeCard);
        activeCard = null;
    }

    function setActive(card) {
        // When activating any card, the default image should not be focused.
        DefaultImage?.classList.remove('focused');

        if (activeCard && activeCard !== card) {
            removeFocus(activeCard);
        }
        applyFocus(card);
        activeCard = card;
    }

    /**
     * Restore the default image focus (image only).
     * Note: We do NOT set a "focused" card for the default image, per your request.
     */
    function restoreDefaultImageFocus() {
        // Clear any active card/image first
        clearActive();
        // Reapply focus to the default image if we have one
        DefaultImage?.classList.add('focused');
    }

    /**
     * Determine if mouseleave is moving into another card element.
     * Uses relatedTarget (the element the pointer entered).
     */
    function isEnteringAnotherCard(leaveEvent) {
        const toElement = leaveEvent.relatedTarget;
        if (!toElement) return false;
        // If moving to another .card--mini-link, we treat it as "entering another card"
        const nextCard = toElement.closest?.('.card--mini-link');

        return !!(nextCard && container?.contains(nextCard));
    }

    //Hook it in to all the cards
    Cards.forEach((card) => {

        // Desktop: focus on hover
        card.addEventListener('mouseenter', () => {
            // Remove default image focus the moment we hover any card
            DefaultImage?.classList.remove('focused');
            setActive(card);
        });

        // Desktop: on leaving THIS card, restore default if not entering another card in THIS instance
        card.addEventListener('mouseleave', (e) => {
            if (isEnteringAnotherCard(e)) return;
            restoreDefaultImageFocus();
        });

        /**
         * Mobile/touch:
         * First tap => focus only (block navigation)
         * Second tap on same card => navigate by triggering the hidden .card__link
         *
         * Keep default image focused on load; remove it as soon as a card is focused.
         */
        let ignoreNextClick = false;

        card.addEventListener(
            'touchend',
            (e) => {
              // Allow taps on inner anchors that are NOT the hidden nav anchor to pass through (e.g., tel:)
              const tappedAnchor = e.target.closest('a');
              if (tappedAnchor && !tappedAnchor.classList.contains('card__link')) {
                return;
              }
      
              if (activeCard !== card) {
                // First tap: remove default focus and focus this card
                DefaultImage?.classList.remove('focused');
                setActive(card);
      
                // Block navigation and suppress the ghost click
                ignoreNextClick = true;
                setTimeout(() => { ignoreNextClick = false; }, 400);
      
                e.preventDefault();
                e.stopPropagation();
                return;
              }
      
              // Second tap: navigate via the hidden link
              const navAnchor = card.querySelector('.card__link');
              if (navAnchor) {
                ignoreNextClick = false; // don't block our own programmatic click
                navAnchor.click();
              }
            },
            { passive: false }
        );

        // Cancel the ghost/synthetic click that may follow the first tap
        card.addEventListener(
            'click',
            (e) => {
            // Only relevant right after a "focus-only" first tap
            if (ignoreNextClick) {
                ignoreNextClick = false;
                e.preventDefault();
                e.stopPropagation();
            }
            },
            true // capture phase
        );

        // Touch: tapping outside THIS instance clears focus and restores default image
        document.addEventListener(
            'touchstart',
            (e) => {
            if (!activeCard) return;                 // nothing active in THIS instance
            if (!instanceRoot.contains(e.target)) {  // tapped outside THIS instance
                restoreDefaultImageFocus();
            }
            },
            { passive: true }
        );
    });
}

if (ContentWithLinkModules.length > 0) {
    ContentWithLinkModules.forEach((module) => {
        initContentWithLinks(module);
    })
}
